var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "div",
        [
          _c("el-card", { staticClass: "employees-card-bottom" }, [
            _c(
              "div",
              [
                _vm.search.length > 0
                  ? _c("oaFromBox", {
                      attrs: {
                        dropdownList: _vm.dropdownList,
                        isAddBtn: true,
                        isViewSearch: false,
                        search: _vm.search,
                        title: "职位管理",
                        total: _vm.total,
                      },
                      on: {
                        addDataFn: _vm.addJob,
                        confirmData: _vm.confirmData,
                        dropdownFn: _vm.dropdownFn,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticClass: "mt10 table-box",
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.tableData,
                          height: _vm.tableHeight,
                          "default-expand-all": "",
                          "row-key": "id",
                        },
                        on: { "selection-change": _vm.handleSelectionChange },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "selection", width: "55" },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("hr.jobtitle"),
                            "min-width": "150",
                            prop: "name",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("hr.immediatesuperior"),
                            "min-width": "150",
                            prop: "cate.name",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("hr.positionlevel"),
                            "min-width": "100",
                            prop: "rank.alias",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "职位简介",
                            "min-width": "240",
                            prop: "describe",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "line1" }, [
                                    _vm._v(_vm._s(scope.row.describe || "--")),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("hr.founder"),
                            "min-width": "120",
                            prop: "card.name",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("public.operation"),
                            prop: "describe",
                            "show-overflow-tooltip": "",
                            width: "200",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            "hr:enterprise:job:jobAdministration:check",
                                          ],
                                          expression:
                                            "['hr:enterprise:job:jobAdministration:check']",
                                        },
                                      ],
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDetail(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("public.check")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            "hr:enterprise:job:jobAdministration:edit",
                                          ],
                                          expression:
                                            "['hr:enterprise:job:jobAdministration:edit']",
                                        },
                                      ],
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("public.edit")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            "hr:enterprise:job:jobAdministration:delete",
                                          ],
                                          expression:
                                            "['hr:enterprise:job:jobAdministration:delete']",
                                        },
                                      ],
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("public.delete")))]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "page-fixed" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.where.page,
                            "page-size": _vm.where.limit,
                            "page-sizes": [15, 20, 30],
                            total: _vm.total,
                            layout: "total,sizes, prev, pager, next, jumper",
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.pageChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-drawer",
                  {
                    attrs: {
                      "before-close": _vm.handleDrawerClose,
                      modal: true,
                      title: _vm.$t("hr.joboetails"),
                      visible: _vm.drawer,
                      "wrapper-closable": true,
                      direction: "rtl",
                      size: "60%",
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.drawer = $event
                      },
                    },
                  },
                  [
                    _vm.detailData
                      ? _c("div", { staticClass: "detail-box" }, [
                          _c("div", { staticClass: "item-box" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("hr.jobtitle")) + ":"),
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(_vm.detailData.name))]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-box" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("hr.numberPosts")) + ":"),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.detailData.job_count)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-box" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("hr.jobdescriptiones")) + ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.detailData.describe)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-box" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("hr.creationtime")) + ":"),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.detailData.created_at)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-box" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("hr.jobresponsibilities")) + ":"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "content-box" }, [
                            _c("div", {
                              staticClass: "content mt20",
                              domProps: {
                                innerHTML: _vm._s(_vm.detailData.duty),
                              },
                            }),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("draweForm", {
        ref: "draweForm",
        attrs: {
          fromData: _vm.fromData,
          formConfig: _vm.formConfig,
          formDataInit: _vm.formDataInit,
          formRules: _vm.formRules,
        },
        on: { submit: _vm.submit, getRankList: _vm.getRankList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }